import { render, staticRenderFns } from "./ValueFieldset.vue?vue&type=template&id=5d7f5cb9&scoped=true&"
import script from "./ValueFieldset.vue?vue&type=script&lang=js&"
export * from "./ValueFieldset.vue?vue&type=script&lang=js&"
import style0 from "./ValueFieldset.vue?vue&type=style&index=0&id=5d7f5cb9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7f5cb9",
  null
  
)

export default component.exports